import React, { useState } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import {
    useGetNiveauxQuery,
    useAddNiveauMutation,
    useUpdateNiveauMutation,
    useDeleteNiveauMutation
} from '../../redux/api/coachApi';

const NiveauxView = () => {
    const [newNiveau, setNewNiveau] = useState({ name: '' });
    const [editingNiveau, setEditingNiveau] = useState(null);
    const [error, setError] = useState('');

    // RTK Query hooks
    const { data: niveaux, isLoading, error: fetchError } = useGetNiveauxQuery();
    const [addNiveau, { isLoading: isAdding }] = useAddNiveauMutation();
    const [updateNiveau, { isLoading: isUpdating }] = useUpdateNiveauMutation();
    const [deleteNiveau, { isLoading: isDeleting }] = useDeleteNiveauMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newNiveau.name.trim()) {
            setError('Le nom du niveau est requis.');
            return;
        }
        setError('');

        try {
            if (editingNiveau) {
                await updateNiveau({ id: editingNiveau.id, ...newNiveau }).unwrap();
            } else {
                await addNiveau(newNiveau).unwrap();
            }
            setNewNiveau({ name: '' });
            setEditingNiveau(null);
        } catch (err) {
            setError(editingNiveau ?
                "Erreur lors de la mise à jour du niveau." :
                "Erreur lors de l'ajout du niveau."
            );
            console.error("Error submitting niveau:", err);
        }
    };

    const handleEdit = (niveau) => {
        setEditingNiveau(niveau);
        setNewNiveau({ name: niveau.name });
    };

    const handleDelete = async (id) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce niveau ?')) {
            try {
                await deleteNiveau(id).unwrap();
            } catch (err) {
                setError("Erreur lors de la suppression du niveau.");
                console.error("Error deleting niveau:", err);
            }
        }
    };

    if (isLoading) {
        return <div className="loading">Chargement des niveaux...</div>;
    }

    if (fetchError) {
        return <div className="error">Erreur lors du chargement des niveaux: {fetchError.message}</div>;
    }

    return (
        <div className="niveaux-view-container">
            {/* Form Card */}
            <div className="form-card">
                <h2>{editingNiveau ? 'Modifier le Niveau' : 'Ajouter un Niveau'}</h2>
                {error && <div className="error-message">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="niveauName">Nom du Niveau</label>
                        <input
                            type="text"
                            id="niveauName"
                            className="form-control"
                            value={newNiveau.name}
                            onChange={(e) => setNewNiveau({ ...newNiveau, name: e.target.value })}
                            placeholder="Entrez le nom du niveau"
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn-add-middle"
                        disabled={isAdding || isUpdating}
                    >
                        {editingNiveau ? 'Mettre à jour' : 'Ajouter'}
                    </button>
                </form>
            </div>

            {/* List Card */}
            <div className="list-card">
                <h2>Liste des Niveaux</h2>
                {niveaux && niveaux.length > 0 ? (
                    <div className="list-items-container">
                        {niveaux.map(niveau => (
                            <div key={niveau.id} className="list-item">
                                <div className="content">
                                    <h3>{niveau.name}</h3>
                                </div>
                                <div className="actions">
                                    <button
                                        className="btn-icon"
                                        onClick={() => handleEdit(niveau)}
                                        disabled={isUpdating}
                                    >
                                        <FiEdit2 />
                                    </button>
                                    <button
                                        className="btn-icon"
                                        onClick={() => handleDelete(niveau.id)}
                                        disabled={isDeleting}
                                    >
                                        <FiTrash2 />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="no-data">Aucun niveau trouvé.</p>
                )}
            </div>
        </div>
    );
};

export default NiveauxView; 